import React from "react";
import { IoMail, IoPaperPlane, IoCallOutline } from "react-icons/io5";
import Max from "components/vector/max";

export const mails = [
  {
    name: "info@mrc-club.ru",
    icon: <IoMail />,
    link: "mailto:info@mrc-club.ru",
  },
];

export const contacts = [
  {
    name: "+7 999 993-17-10",
    icon: <IoCallOutline />,
    link: "tel:+79999931710",
  },
  {
    name: "+7 910 468-00-10",
    icon: <IoCallOutline />,
    link: "tel:+79104680010",
  },

  {
    name: "Max",
    icon: <Max />,
    link: "https://max.ru/u/f9LHodD0cOKA8eT5jpAZ51tqL6myfYRg8wy5o9MLvATnCdrX2EVa7DkYAJE",
  },
  {
    name: "Telegram",
    icon: <IoPaperPlane />,
    link: "https://t.me/+79999931710",
  },
];

export const links = [
  {
    name: "Я эксперт",
    href: "/",
  },
  {
    name: "Я журналист",
    href: "/journalist",
  },
  {
    name: "О нас",
    href: "/about",
  },
  {
    name: "Публикации в СМИ",
    href: "/media",
  },
  {
    name: "База знаний",
    href: "/publication",
  },
  {
    name: "Пресс-мероприятия",
    href: "/pressevents",
  },
  {
    name: "Запросы СМИ",
    href: "/request",
  },
  {
    name: "Тарифы и условия",
    href: "/request#tariff",
  },
  {
    name: "Услуги",
    href: "/#services",
  },
];
